export default {
    // disintegrate: {
    //     origin: { opacity: 1, scale: 1 },
    //     destination: { opacity: 0, scale: 1.2 },
    // },
    // focus: {
    //     origin: { scale: 1.2, filter: "blur(8px)" },
    //     destination: { scale: 1, filter: "blur(0px)" },
    // },
    shatter: {
        origin: { opacity: 1, scale: 1, filter: "blur(0px)" },
        destination: { opacity: 0, scale: 1.2, filter: "blur(8px)" },
    },
};
